import { Offer, ProductV2 } from '@common'

export type ProductOffer = ProductV2 & { offerData: Offer }

export const isProductOffer = (product: ProductV2): product is ProductOffer => product.offerData !== null
export const isSeasonPass = (product: ProductV2) => !!product.contentCounts.SEASON_PASS

export type ProductCurrencyType = keyof Omit<ProductV2['contentCounts'], 'SEASON_PASS'>
export const getProductCurrencyType = (product: ProductV2): ProductCurrencyType | undefined => {
  if (product.contentCounts.COIN) {
    return 'COIN'
  }
  if (product.contentCounts.GEM) {
    return 'GEM'
  }
}

export const isSameProductType = (a: ProductV2, b: ProductV2) => {
  return Object.keys(a.contentCounts).some((t) => Object.keys(b.contentCounts).includes(t))
}

export const findProductByHashOrId =
  <T extends ProductV2>(hashOrId: string) =>
  (product: T) =>
    product.hash === hashOrId || product.id === hashOrId

const containsType = (type: keyof ProductV2['contentCounts']) => (p: ProductV2) => (p.contentCounts[type] || 0) > 0

const check = (type: keyof ProductV2['contentCounts'], a: ProductV2, b: ProductV2) => {
  const cb = containsType(type)
  if (cb(a) && cb(b)) {
    const priceA = Object.values(a.prices)[0]
    const priceB = Object.values(b.prices)[0]
    return priceB - priceA
  }
  if (cb(a) && !cb(b)) {
    return -1
  } else if (cb(b) && !cb(a)) {
    return 1
  } else {
    return undefined
  }
}

const checkOffer = (a: ProductV2, b: ProductV2) => {
  if (a.offerData && !b.offerData) {
    return -1
  } else if (b.offerData && !a.offerData) {
    return 1
  } else if (a.offerData !== null && b.offerData !== null && b.offerData.priority !== a.offerData.priority) {
    // in priorities lower = higher priority
    return a.offerData.priority - b.offerData.priority
  } else {
    return undefined
  }
}

export const sortProducts = (a: ProductV2, b: ProductV2): number => {
  // Offer (priority -> pass -> diamonds -> coins)
  // Regular: pass -> diamonds -> price -> coins
  // Price descending
  const offerRes = checkOffer(a, b)
  if (offerRes) {
    return offerRes
  }
  const passRes = check('SEASON_PASS', a, b)
  if (passRes) {
    return passRes
  }
  const diamondRes = check('GEM', a, b)
  if (diamondRes) {
    return diamondRes
  }

  const coinRes = check('COIN', a, b)
  if (coinRes) {
    return coinRes
  }
  return 0
}
